import React, { PureComponent } from 'react';
import NoUiSlider from 'react-nouislider';

import * as AppActions from '../../modules/App/AppState';

import 'nouislider/distribute/nouislider.css';

class UiSlider extends PureComponent {
  constructor() {
    super();
    this.onUpdate = this.onUpdate.bind(this);
    this.format = this.format.bind(this);
  }

  format(num) {
    return {
      to: function ( num ) {
      return num + '';
      },
    }
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.isPlaying !== this.props.isPlaying || nextProps.year !== this.props.year) {
      this.refs.sliderComponent.slider.set([nextProps.year]);
    }
    return false;
  }

  onUpdate(evt) {
    this.props.dispatch(AppActions.setYear(parseInt(evt[0], 10)));
  }

  render() {
    return (<NoUiSlider
      range={{ min: 1991, max: 2014 }}
      start={[this.props.year]}
      step={1}
      pips={{mode: 'steps', density: 100}}
      onChange={this.onUpdate}
      ref="sliderComponent"
      tooltips={[this.format()]}
    />)
  }
}

export default UiSlider;



/** WEBPACK FOOTER **
 ** ./src/components/Slider/NoUiSlider.js
 **/